import Vue from 'vue';
import Router from 'vue-router';

// Import the components
import Dibble from '../components/Dibble'
import Auth from "../components/Auth/Auth";
import Dashboard from "../components/Dashboard/Dashboard";
import Users from "../components/Users/Users";
import BusinessProfileUsers from "../components/Users/BusinessProfileUsers";
import AppReports from '../components/AppReports/AppReports.vue'
import MemoDetailsPage from '../components/AppReports/MemoDetailsPage.vue'
import Questionnaire from '../components/Questionnaire/Questionnaire.vue'
import Feedbacks from '../components/Feedback/Feedbacks.vue'
import Message from '../components/Message/Message.vue'
import FeedbackReasons from '../components/Feedback/FeedbacksReason.vue'

Vue.use(Router);

const router = new Router({
    mode: 'history',
    linkActiveClass: 'active',
    routes: definedRoutes()
});

function definedRoutes() {
    return [
        {
            path: '/login',
            name: 'Login',
            component: Auth
        },
        {
            path: '/',
            name: 'Home',
            component: Dibble
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
            meta: {
                title: 'Dashboard'
            }
        },
        {
            path: '/users',
            name: 'users-list',
            component: Users,
            meta: {
                title: 'Users List'
            }
        },
        {
            path: '/business-users',
            name: 'business-users-list',
            component: BusinessProfileUsers,
            meta: {
                title: 'Business Users List'
            }
        },
        {
            path: '/feedbacks',
            name: 'feedbacks',
            component: Feedbacks,
            meta: {
                title: 'Feedback List'
            }
        },
        {
            path: '/feedback-reasons',
            name: 'feedback-reasons',
            component: FeedbackReasons,
            meta: {
                title: 'Feedback Reason List'
            }
        },
        {
            path: '/message',
            name: 'message',
            component: Message,
            meta: {
                title: 'Message List'
            }
        },
        {
            path: '/app-reports',
            name: 'app-reports',
            component: AppReports,
            meta: {
                title: 'App reports'
            }
        },
        {
            path: '/questionnaire',
            name: 'questionnaire',
            component: Questionnaire,
            meta: {
                title: 'Questionnaire'
            }
        },
        {
            path: '/memo/:memo_id',
            name: 'Memory Comment',
            component: MemoDetailsPage
          },
    ];
}

export default router;
